import { render, staticRenderFns } from "./affiliate_policy.vue?vue&type=template&id=4fc7c9f2&"
import script from "./affiliate_policy.vue?vue&type=script&lang=js&"
export * from "./affiliate_policy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports